<template>
  <div class="wrap-content">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.wrap-content {
  width: 100%;
  padding: 2.5rem;
}
</style>
